import moment from 'moment';

import {FY} from '../pages/esgManager/constants/FrameWorksConst';

const checkSelectedYear: (selectedYear: string) => boolean = (selectedYear) => {
  if (selectedYear.includes('-')) {
    const yearSplit = selectedYear.split('-');
    const year1 = Number(yearSplit?.[0]);
    const year2 = Number(yearSplit?.[1]);

    if (!isNaN(year1) && !isNaN(year2)) {
      if (
        year1 >= 2000 &&
        year2 > 2000 &&
        year1 <= moment().year() &&
        year2 <= moment().add(1, 'year').year()
      ) {
        return Math.abs(year2 - year1) === 1;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const replaceCurrentAndPrevious: (
  string: string,
  selectedYear: string
) => string = (string, selectedYear) => {
  if (checkSelectedYear(selectedYear)) {
    const yearSplit = selectedYear.split('-');
    const year1 = Number(yearSplit?.[0]);
    const year2 = Number(yearSplit?.[1]);

    return string
      ?.replace(FY.current, selectedYear)
      .replace(FY.previous, `${year1 - 1}-${year2 - 1}`)
      .replace(FY.previousToPrevious, `${year1 - 2}-${year2 - 2}`);
  } else {
    return '';
  }
};

export default checkSelectedYear;
